import LayoutEnter from './components/layoutEnter/layoutEnter.tsx'
import { SiteName } from './components/siteName/siteName.tsx'
import { useSpring, useTransition } from '@react-spring/web'
import { useLocation } from 'react-router-dom'
import { Menu } from './components/menu/menu.tsx'
import { Formula } from './components/formula/formula.tsx'
import { OpenButton } from './components/openButton/openButton.tsx'
import { GlassModal } from './components/glassModal/glassModal.tsx'
import { GlassModalFromMenu } from './components/glassModallFromMenu/glassModalFromMenu.tsx'
import { useEffect, useRef, useState } from 'react'


function App() {
  const location = useLocation()

  const [openModal, setOpenModal] = useState(false)
  const [openModalFromMenu, setOpenModalFromMenu] = useState(false)
  const modalRef = useRef<HTMLDivElement>(null)

  const transitions = useTransition(location, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 1 },
  })

  const WaterDatabaseProp = useSpring({
    from: { x: -300, opacity: 0 },
    to: { x: 0, opacity: 1 },
    config: { duration: 500 },
    delay: 1000,
  })



  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpenModal(false)
        setOpenModalFromMenu(false)
      }
    }

    const handleOutsideClick = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        setOpenModal(false)
        setOpenModalFromMenu(false)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  return (transitions((style) =>
    <LayoutEnter>
      <div style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxHeight: '10vh',
        marginTop: '4vh',
      }}>
        <Menu openModalFromMenu={() => setOpenModalFromMenu(true)} />
        <SiteName />
      </div>

      {
        openModalFromMenu &&
        <div style={{
          position: 'absolute',
          width: '100vw',
          height: '100vh',
          top: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <GlassModalFromMenu ref={modalRef} />
        </div>
      }

      <div style={{
        marginLeft: '4vw',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '15vw',
      }}>
        <Formula />
        <OpenButton onClickButton={() => setOpenModal(true)} />
      </div>

      {
        openModal &&
        <div style={{
          position: 'absolute',
          width: '100vw',
          height: '100vh',
          top: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <GlassModal ref={modalRef} />
        </div>
      }
    </LayoutEnter>,
  ))
}

export default App
